<template>
  <div :id="`${inputId}-label`" :class="['form-label', { required: required }]">{{ label }}</div>
  <slot :state="state"
        :updateState="updateState"
        :required="required"
        :inputId="inputId"
        :aria-labelledby="`${inputId}-label`"
        :aria-describedby="`${inputId}-error`"></slot>
  <div v-if="state && !showWarning" class="text-danger" role="alert" :id="`${inputId}-error`">{{ errorMessage }}</div>
  <div v-if="state && showWarning" class="mdh-text-warning" role="alert" :id="`${inputId}-warning`">{{ errorMessage }}</div>
  <div v-else-if="hint" class="hint ms-2 mt-1" :id="`${inputId}-hint`">{{ hint }}</div>
</template>
  
  <script setup>
  const emit = defineEmits(['update:state']);
  
  const updateState = (value) => {
      emit('update:state', value);
  };
  
  defineProps({
    inputId: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    state: {
      type: Boolean,
      required: true
    },
    errorMessage: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    showWarning: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    },
  });
  </script>